var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#272B39",
    stroke: "#464A5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 23.5H18.25C22 23.5 23.5 22 23.5 18.25V13.75C23.5 10 22 8.5 18.25 8.5H13.75C10 8.5 8.5 10 8.5 13.75V18.25C8.5 22 10 23.5 13.75 23.5Z",
    stroke: "#A09FC6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.5C14.5784 14.5 15.25 13.8284 15.25 13C15.25 12.1716 14.5784 11.5 13.75 11.5C12.9216 11.5 12.25 12.1716 12.25 13C12.25 13.8284 12.9216 14.5 13.75 14.5Z",
    stroke: "#A09FC6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00293 21.2125L12.7004 18.73C13.2929 18.3325 14.1479 18.3775 14.6804 18.835L14.9279 19.0525C15.5129 19.555 16.4579 19.555 17.0429 19.0525L20.1629 16.375C20.7479 15.8725 21.6929 15.8725 22.2779 16.375L23.5004 17.425",
    stroke: "#A09FC6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/imageUploadIcon.970ad7c59f3d935fcf7a890899907d7f.svg";
export { ForwardRef as ReactComponent };